import { PureComponent } from "react";
import Segments from "/components/segments";

export default class BaseSegmentComponent extends PureComponent {
  render() {
    const { segment, isUserLoggedIn, extraProps } = this.props;
    const SegmentComponent = Segments[segment.type];
    return <SegmentComponent {...extraProps} {...segment.props} isUserLoggedIn={isUserLoggedIn} />;
  }
}
BaseSegmentComponent.defaultProps = {
  extraProps: {}
};
